// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"901ff2b3","337":"f53aeba7","344":"c1ef7ff0","536":"28bf14f8","585":"68c085b3","787":"23c458bb"}[chunkId] + ".chunk.js";
};